import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Header } from "../../../components/header/Header";
import { EventCard } from "../../../components/event/EventCard";
import { useDispatch, useSelector } from "react-redux";
import { getAllEventsThunk } from "../../../slices/events/thunk";
import { createSelector } from "@reduxjs/toolkit";

export const EventsList = () => {

  const dispatch = useDispatch();

  // Selector for user state
  const selectEventState = (state) => state.data;
  const eventSelector = createSelector(selectEventState, (event) => ({
    isLoading: event.isLoading,
    data: event.data,
  }));

  // const { isLoading, data } = useSelector(eventSelector);
  const { isLoading, data } = useSelector((state) => state.event);
  const fileUrl = process.env.REACT_APP_FILE_URL;

 

  // Fetch user list whenever active tab changes
  useEffect(() => {
    dispatch(getAllEventsThunk());
  }, [dispatch]);

  
  // Map user data for artist cards
  var cardsData = Array.isArray(data)
  ?
    data.map((da) => ({
      id: da.id,
      title: da.title?? '',
      description: da.description?? '',
      discount: da.discount??'',
      from_date: da.from_date??'',
      to_date: da.to_date??'',
      status: da.status ??'enable',
      
      image: da.image ? `${fileUrl}/${da.image}` : null,
    })) : [];

    

   
   

  return (
    <>
      <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color">
        <Header name="" />
      </header>

      <div className="w-full mx-auto bg-[#F7F7F7]">
        <div className="w-full">
          <div className="w-full flex items-center justify-between mt-4">
            <span className="font-bold text-black text-[22px] font-grotesk">
              Events
            </span>

            
              <Link
                to="/admin/create-event"
                className="bg-primary text-white px-4 py-2 rounded-lg shadow hover:bg-primary/90 transition"
              >
                Add Event
              </Link>
            
          </div>



          {/* Artist Cards */}
          <div className="w-full mt-6 mb-5">
            {isLoading ? (
              <div className="w-full mx-auto grid gap-3 sm:gap-4 grid-cols-1 xs:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6" aria-busy="true">
                {Array.from({ length: 8 }).map((_, idx) => (
                  <div key={idx} className="w-full border border-border_color p-3 rounded-xl animate-pulse">
                    <div className="w-full h-[192px] rounded bg-gray-200" />
                    <div className="mt-[6px]">
                      <div className="h-4 bg-gray-200 rounded w-3/5 mb-2" />
                      <div className="h-3 bg-gray-200 rounded w-2/5" />
                      <div className="flex items-center justify-center gap-2 w-full mt-3">
                        <div className="h-10 bg-gray-200 rounded w-full" />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : cardsData && cardsData.length > 0 ? (
              <EventCard events={cardsData}  />
            ) : (
              <p className="text-center text-gray-500">No event found</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
